<script setup lang="ts">
  const modal = ref(false);
  const planId = ref<string>("");
  const userId = ref<string>("");

  const reviewModified = ref(false);

  const emit = defineEmits(["onClose"]);

  const openModal = (reviewPlanId: string, reviewUserId: string) => {
    planId.value = reviewPlanId;
    userId.value = reviewUserId;
    modal.value = true;
  };

  watch(
    () => modal.value,
    (newValue, oldValue) => {
      if (oldValue !== newValue && !newValue) {
        emit("onClose", reviewModified.value);
      }
    },
  );

  defineExpose({
    openModal,
  });
</script>

<template>
  <v-dialog v-model="modal" width="906" scrim="black">
    <v-card class="review-dialog">
      <v-btn class="close-btn" icon="$close" variant="text" @click="modal = false"></v-btn>
      <OrganismsPlanReviewView
        :plan-id="planId"
        :user-id="userId"
        @on-modified="reviewModified = true"
        @on-deleted="modal = false"
      ></OrganismsPlanReviewView>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";

  .review-dialog {
    position: relative;
    text-align: center;
    background-color: #222222;
    padding: 40px 60px;
    @include display_sp {
      padding: 40px 20px;
    }
    .close-btn {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
</style>
